module.exports = __webpack_public_path__ + "static/media/logo.4aec9714.png";